import styled from 'styled-components';
import React, { useState, useEffect, useRef } from 'react';
import Slide from '../slide.js';
import Slide_img from '../img/ai_image_3_origin.jpg';

function Resources() {
	return (
		<Wrapper>
			<Slide imgURL={Slide_img} inputText="Resources And Links" />
			<Iwrapper>
				<Title_span_>Links</Title_span_>

				<br />
				<IN_Span>
					<Title_span>
						<Point_span />
						<Table_title href="http://210.117.211.210:8501/" target="_blank">
							PROCA
						</Table_title>
						<Item_content>
							Prostate Cancer Treatment Advisor: Friendly advice from patients
							like you
						</Item_content>
					</Title_span>
				</IN_Span>
			</Iwrapper>
			<Iwrapper></Iwrapper>
		</Wrapper>
	);
}

const Wrapper_div = styled.div`
	margin: 0 10%;
`;

const Wrapper = styled.div`
	width: 1200px;
	margin: 0px auto;
	padding: 50px 0;
`;

const Iwrapper = styled.div`
	position: relative;

	margin: 50px auto;
	padding-left: 120px;
	padding-right: 120px;
`;

const Title_span_ = styled.span`
	font-family: 'Title';
	display: inline-block;
	font-size: 35px;
	font-weight: bold;
	margin-top: 50px;
`;

const Title_span = styled.span`
	display: inline-block;
	font-size: 35px;
	font-weight: bold;
	margin: 50px 0;
`;

const Table_title = styled.a`
	font-family: 'Lucida Calligraphy', cursive;
	margin: 10px 0;
	color: #32a4ff;
	font-weight: bold;
	&:hover {
		cursor: pointer;
	}
`;

const IN_Span = styled.span`
	display: block;
	padding: 10px 20px;
	font-size: 20px;
	line-height: 30px;
	color: #212121;
	background: #ffffff;
`;

const Point_span = styled.span`
	background: #32a4ff;
	width: 5px;
	height: 5px;
	line-height: 25px;
	display: inline-block;
	border-radius: 100%;
	vertical-align: middle;
	margin: 0 10px;
`;

const Item_content = styled.div`
	font-size: 20px;
	text-align: left;
	padding: 20px 5px;
	line-height: 26px;
	font-family: 'People_content';
	margin-left: 15px;
`;
export default Resources;
